import { DetailedProcessComponent } from './detailed-process/detailed-process.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from './admin.component';
import { QuestionListComponent } from './question-list/question-list.component';
import { ProcessesListComponent } from './processes-list/processes-list.component';
import { ReportsComponent } from './reports/reports.component';
import { SurveyEditorComponent } from './survey-editor/survey-editor.component';
import { ProcessBuilderComponent } from './processes-list/process-builder/process-builder.component';
import { AdminSurveyListComponent } from './survey/admin-survey-list.component';
import { AdditionalAdminFeaturesComponent } from './additional-admin-features/additional-admin-features.component';

const adminRoutes: Routes = [
    {
        path: 'admin', component: AdminComponent,
        children: [
  { path: 'question-list', component: QuestionListComponent },
  { path: 'question-list/:id', component: QuestionListComponent },
  { path: 'processes-list', component: ProcessesListComponent },
  { path: 'survey-list', component: AdminSurveyListComponent },
  { path: 'survey-editor', component: SurveyEditorComponent },
  { path: 'reports', component: ReportsComponent },
  { path: 'process-builder', component: ProcessBuilderComponent },
  { path: 'detailed-process', component: DetailedProcessComponent},
  { path: 'extra', component: AdditionalAdminFeaturesComponent }
]
    },
  
];

@NgModule({
  imports: [
    RouterModule.forChild(adminRoutes)
  ],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class AdminRouteModule { }
